import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faChevronUp } from '@fortawesome/pro-light-svg-icons';

export type ProLightChevronUpProps = IconComponentProps;

export const ProLightChevronUp = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightChevronUpProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faChevronUp}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faChevronUp}
    />
  );
};

ProLightChevronUp.displayName = 'ProLightChevronUp';
